<template>
    <div class="modal-loader modal-mask">
        <loader-spinner :isDisplay="true"></loader-spinner>
    </div>
</template>

<script>
export default {
    methods: {
        hide() {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.modal-mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.65);
}

.modal-loader {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>